 function isValidAirIndiaId(id) {
    // Must be exactly 9 digits
    if (!/^\d{9}$/.test(id)) {
      return false;
    }

    // First 8 digits
    const firstEight = id.substring(0, 8);
    const checkDigit = parseInt(id.charAt(8), 10);

    let total = 0;

    for (let i = 0; i < 8; i++) {
      const digit = parseInt(firstEight.charAt(i), 10);

      // Reverse index: 8,7,6,5,4,3,2,1
      const multiplier = 8 - i;

      let product = digit * multiplier;

      // If product is two digits, add those digits once
      if (product >= 10) {
        product = Math.floor(product / 10) + (product % 10);
      }

      total += product;
    }

    // Calculate expected check digit
    const expectedDigit = total % 7;

    return expectedDigit === checkDigit;
  }


 document.addEventListener("DOMContentLoaded", () => {
  const customInput = document.getElementById("custom-input");
  const saveBtn = document.getElementById("save-btn");
  const message = document.getElementById("message");
  const failMessage = document.getElementById("failed_message");
  const shopAll = document.getElementById("shop-all-btn");

  // Exit if the form isn't on this page
  if (!customInput || !saveBtn) return;

  // Only allow digits
  customInput.addEventListener("input", function () {
    this.value = this.value.replace(/\D/g, "").slice(0, 9);
  });

  saveBtn.addEventListener("click", function () {
    const customValue = customInput.value;

    if (customValue.trim() === "") {
      // alert("Please enter an ID.");
      message.style.display = "none";
      failMessage.style.display = "block"
      return;
    }

    if (customValue.length > 9) {
      // alert("Please enter maximum 9 digits only.");
      message.style.display = "none";
      failMessage.style.display = "block"
      return;
    }

    if (!isValidAirIndiaId(customValue)) {
      // alert("Invalid Air India ID.");
          message.style.display = "none";
      failMessage.style.display = "block"
      return;
    }

    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        attributes: {
          air_india_id: customValue,
        },
      }),
    })
      .then((response) => response.json())
      .then(() => {
        if (message) {
          failMessage.style.display = "none"
          message.style.display = "block";
          shopAll.style.display = "block";
        }

        setTimeout(() => {
          window.scrollBy({
            top: 400,
            behavior: "smooth",
          });
        }, 300);
      })
      .catch((error) => console.error("Error:", error));
  });
});